import { ApplicationState } from './crossSliceReducer'

export const isSystemUser = (admin: ApplicationState['auth']['admin']) => {
  if (admin.isLogin === false) {
    return false
  }
  return admin.manufacturerId === undefined
}
